import { useState, useEffect } from 'react';
import { Stack, Container, Typography, Card, Box, Button } from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { getApi } from 'views/services/api';
import { useNavigate } from 'react-router';

const ViewInvoices = () => {
  const hotelId = JSON.parse(localStorage.getItem('hotelData')).hotelId;
  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = useState([]);
  const [reservationIds, setReservationId] = useState([]);

  const fetchInvoiceData = async () => {
    try {
      const response = await getApi(`api/invoice/viewallinvoice/${hotelId}`);
      setInvoiceData(response?.data?.invoiceData ?? []);
      
      const reservationids = response.data?.invoiceData.map(item => item.reservationId) || [];
      setReservationId(reservationids);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSingleBillData = async () => {
    try {
      reservationIds.map(async (reservationId) => {
        const response = await getApi(`api/singleinvoice/view/${reservationId}`);
        
        response?.data?.InvoiceData && setInvoiceData((prevData) => [...prevData, ...response.data.InvoiceData]);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInvoiceData();
  }, []);

  useEffect(() => {
    if (reservationIds.length > 0) {
      fetchSingleBillData();
    }
  }, [reservationIds]);

  const handleGenerateBill = (billItem) => {
    if (billItem.type === "room" || billItem.type === "food") {
      navigate(`/roombill/view/${billItem._id}`);
    } else {
      navigate(`/singlebill/view/${billItem.reservationId}`);
    }
  };

  const columns = [
    {
      field: `invoiceNumber`,
      headerName: 'Invoice Number',
      flex: 2,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => (
        <Box>
          <Box onClick={() => handleGenerateBill(params?.row)}>{params.value || 'N/A'}</Box>
        </Box>
      ),
    },
    {
      field: `name`,
      headerName: 'Name',
      flex: 2,
      cellClassName: ' name-column--cell--capitalize',
      renderCell: (params) => (
        <Box>
          <Box>{params.value || 'N/A'}</Box>
          <div style={{ marginTop: '4px', fontSize: '12px', color: '#777' }}>
            {params.row.customerPhoneNumber || 'N/A'}
          </div>
        </Box>
      ),
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 2,
      renderCell: (params) => <Box>{params.value || 'N/A'}</Box>,
    },
    {
      field: 'type',
      headerName: 'Invoice Type',
      flex: 1,
      renderCell: (params) => <Box>{params.row.type || 'Food+Room'}</Box>,
    },
    {
      field: 'foodAmount',
      headerName: 'Food Amount',
      flex: 1,
      renderCell: (params) => (
        <Box>
          {params.row.totalFoodAmount
            ? `${hotel?.currencyCode} ${params.row.totalFoodAmount}`
            : params.row.foodAmount
            ? `${hotel?.currencyCode} ${params.row.foodAmount}`
            : 'N/A'}
        </Box>
      ),
    },
    {
      field: 'roomRent',
      headerName: 'Room Amount',
      flex: 1,
      renderCell: (params) => (
        <Box>
          {params.row.totalRoomAmount
            ? `${hotel?.currencyCode} ${params.row.totalRoomAmount}`
            : params.row.roomRent
            ? `${hotel?.currencyCode} ${params.row.roomRent}`
            : 'N/A'}
        </Box>
      ),
    },
    {
      field: 'advanceAmount',
      headerName: 'Advance Amount',
      flex: 1,
      renderCell: (params) => (
        <Box>
          {params.row.advanceAmount
            ? `${hotel?.currencyCode} ${params.row.advanceAmount}`
            : 'N/A'}
        </Box>
      ),
    },
    {
      field: 'discount',
      headerName: 'Discount',
      flex: 1,
      renderCell: (params) => {
        const discount = params.value || 0;
        return <Box>{discount > 0 ? `${hotel?.currencyCode} ${discount}` : 'N/A'}</Box>;
      },
    },
    {
      field: 'totalAmount',
      headerName: 'Total Amount',
      flex: 1,
      renderCell: (params) => (
        <Box>
          {params.row.totalAmount
            ? `${hotel?.currencyCode} ${params.row.totalAmount}`
            : params.row.totalFoodAndRoomAmount
            ? `${hotel?.currencyCode} ${params.row.totalFoodAndRoomAmount}`
            : 'N/A'}
        </Box>
      ),
    },
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Customer Invoices</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '500px', paddingTop: '15px' }}>
              <DataGrid
                rows={invoiceData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default ViewInvoices;
